import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

import { useAreTutorialsBlocked } from '../context/tutorialsBlockedContext'

/**
 * Whether a tutorial or education tooltip is still due to be shown: it has not been viewed and no
 * overlay is blocking tutorials. Blocking never marks a tutorial as viewed, so it is due again as
 * soon as the overlay closes.
 */
export const useIsTutorialPending = (name: string): boolean => {
  const hasViewed = useSelector(({ tutorial }: RootStateOrAny) =>
    Boolean(tutorial && tutorial.getIn(['viewed', name])),
  )
  const areTutorialsBlocked = useAreTutorialsBlocked()

  return !hasViewed && !areTutorialsBlocked
}
